/* @flow */
import * as React from 'react';

import {AttributionReportDescription} from './attribution/attribution-report-description';

export const getAttributionReportDescription = () => <AttributionReportDescription />;
